import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ForgottenPasswordPageRoutingModule } from './forgottenpassword-routing.module';
import { ForgottenPasswordPageComponent } from './forgottenpassword.component';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [ForgottenPasswordPageComponent],
  imports: [
    CommonModule,
    ForgottenPasswordPageRoutingModule,
    SharedModule
  ]
})
export class ForgottenPasswordPageModule { }
